import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@utils/api";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { onboardingQKeys } from "@hooks/queries/onboarding/queryKeys";

export const useUploadDocument = () => {
  const handleErrors = useQueryErrorHandling();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ documentType, file }: { documentType: string; file: File }) => {
      const formData = new FormData();
      formData.append("file", file);
      
      return api.post(`onboarding/session/me/upload`, formData, {
        params: { document_type: documentType },
        headers: { "Content-Type": "multipart/form-data" },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: onboardingQKeys.session() });
    },
    onError: (res: any) => {
      console.error("[From Upload Document]", res);
      handleErrors(res, "mutation");
    },
  });
};
